import React from 'react';

import PageSkeleton from '../../components/skeleton/PageSkeleton';
import createRouteLoadable from './createRouteLoadable';

export const ORDER_CANCELLATION_CHUNK_NAME = 'orderCancellation';

export const OrderCancellationPage = createRouteLoadable(
  () =>
    import(
      /* webpackChunkName: "orderCancellation" */ '../../pages/OrderCancellationPage'
    ),
  {
    fallback: <PageSkeleton />,
  }
);
